// ─── src/types/ecosystemPerception.ts ────────────────────────────────────────

export type Indicator =
  | "trust"
  | "awareness"
  | "reach"
  | "value"
  | "belonging"
  | "communication"
  | "alignment";

export const INDICATOR_LABELS: Record<Indicator, string> = {
  trust:         "Trust",
  awareness:     "Awareness",
  reach:         "Reach",
  value:         "Value",
  belonging:     "Belonging",
  communication: "Communication",
  alignment:     "Needs Alignment",
};

export interface EcosystemResponse {
  id: string;
  fullNameAr: string;
  governorate: string;
  cityArea: string;
  ageGroup: string;
  gender: string;
  professionalStatus: string;
  roleWithStartupSyria: string;
  answers: Record<string, string | string[]>;
  scores: Record<string, number>;
  nps: number;
  createdAt: string;
  updatedAt: string;
}

export interface EcosystemResponseList {
  data: EcosystemResponse[];
  total: number;
  page: number;
  limit: number;
}

export type NpsBucket = "promoter" | "passive" | "detractor";

/** Shared filter shape — same keys are accepted by /stats and the list. */
export interface EcosystemFilters {
  search?: string;
  governorate?: string;
  role?: string;
  gender?: string;
  ageGroup?: string;
  professionalStatus?: string;
  dateFrom?: string; // YYYY-MM-DD
  dateTo?: string;   // YYYY-MM-DD
  npsBucket?: NpsBucket;
}

export interface EcosystemParams extends EcosystemFilters {
  page?: number;
  limit?: number;
}

export interface EcosystemStats {
  total: number;
  indicatorAverages: Record<string, number>;
  indicatorAveragesByGovernorate: Record<string, Record<string, number>>;
  nps: { score: number; promoters: number; passives: number; detractors: number };
  byGovernorate: Record<string, number>;
  byAgeGroup: Record<string, number>;
  byGender: Record<string, number>;
  byRole: Record<string, number>;
  byProfessionalStatus: Record<string, number>;
  programAwareness: Record<string, number>;
  priorities: Record<string, number>;
  communicationGaps: Record<string, number>;
}
